import { Box, Stack } from '@mui/material'
import {
	firstDayHandler,
	getDaysBetweenDates,
} from 'components/shared/processes'
import { useState } from 'react'

import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { DateRestriction } from 'ui/DatePickerInput'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'
import { sxList } from '../utils/headChartStyles'
import GroupApexChart from './GroupApexChart'

interface IGroupSpecificFoodtableAvailable {
	id: number
	group_title: string
}

export const GroupSpecificFoodtableAvailable = (
	props: IGroupSpecificFoodtableAvailable,
) => {
	const primaryDateState = firstDayHandler()
	const [dateRange, setDateRange] = useState({
		startDate: null,
		endDate: null,
	})
	const daysBetweenDates = getDaysBetweenDates(dateRange)
	const onChangeCallback = value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1] + 86399000,
		})
	}
	const sx = sxList(true)

	return (
		<Box sx={sx}>
			<Stack
				direction={'row'}
				justifyContent={'space-between'}
				alignItems={'center'}
			>
				<TypographyHeader>{'Состояние кормового стола'}</TypographyHeader>
			</Stack>
			<Box
				sx={{
					mt: '24px',
					'&:hover': { backgroundColor: 'transparent' },
				}}
			>
				<Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
					<Box
						sx={{
							marginBottom: '24px',
						}}
					>
						<DateRangePicker
							onChangeUpdateDate={onChangeCallback}
							startDate={primaryDateState[0]}
							endDate={primaryDateState[1]}
							todayFilter={true}
							weekFilter={true}
							monthFilter={true}
							currentRange={'Сегодня'}
							restrictionType={DateRestriction.PAST}
						/>
					</Box>

					<Box sx={{ width: '99%' }}>
						<GroupApexChart
							id={props.id}
							startDate={dateRange.startDate}
							endDate={dateRange.endDate}
							daysBetweenDates={daysBetweenDates}
							group_title={props.group_title}
						/>
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

export default GroupSpecificFoodtableAvailable

GroupSpecificFoodtableAvailable.displayName = 'GroupSpecificFoodtableAvailable'
